/* eslint-disable react/jsx-wrap-multilines */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ChangeGroupModalComponent } from '../change-group-modal';
import { ChangeWayModalComponent } from '../change-way-modal';
import './styles.less';
import { CreateReqModalComponent } from '../create-req-modal';

const WayContextWrapper = ({ contextMenu, setContextMenu, selectedCollection, selectedOrders, way }) => {
	const isPlanning = way?.planning;

	if (isPlanning && (selectedCollection?.length > 0 || selectedOrders?.length > 0)) return null;

	const count = (selectedCollection?.length ?? 0) + (selectedOrders?.length ?? 0);

	let disabled = false;
	if (count === 0 && way?.orders_count === 0) {
		disabled = true;
	}

	const [isChangeGroupModalShown, setIsChangeGroupModalShown] = useState(false);

	const [isChangeWayModalShown, setIsChangeWayModalShown] = useState(false);

	const [isCreateReqModalShown, setIsCreateReqModalShown] = useState(false);

	const handleClose = () => {
		setContextMenu(null);
	};

	const changeGroupModal = () => {
		setContextMenu(null);
		setIsChangeGroupModalShown(true);
	};

	const changeWayModal = () => {
		setContextMenu(null);
		setIsChangeWayModalShown(true);
	};

	const createReqModal = () => {
		setContextMenu(null);
		setIsCreateReqModalShown(true);
	};

	return (
		<>
			<Menu
				className="way-context-menu"
				open={contextMenu !== null}
				onClose={handleClose}
				anchorReference="anchorPosition"
				anchorPosition={
					contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined
				}
			>
				<>
					{!selectedCollection && !selectedOrders && (
						<MenuItem disabled={disabled} onClick={createReqModal}>
							Создать заявку{count ? ` (${count})` : ''}
						</MenuItem>
					)}
					<MenuItem disabled={disabled} onClick={changeGroupModal}>
						Переместить в группу{count ? ` (${count})` : ''}
					</MenuItem>
					<MenuItem disabled={disabled} onClick={changeWayModal}>
						Переместить в маршрут{count ? ` (${count})` : ''}
					</MenuItem>
				</>
			</Menu>

			{isChangeGroupModalShown && (
				<ChangeGroupModalComponent
					isModalShown={isChangeGroupModalShown}
					setIsModalShown={setIsChangeGroupModalShown}
					collection={selectedCollection}
					orders={selectedOrders}
					way={way}
				/>
			)}

			{isChangeWayModalShown && (
				<ChangeWayModalComponent
					isModalShown={isChangeWayModalShown}
					setIsModalShown={setIsChangeWayModalShown}
					collection={selectedCollection}
					orders={selectedOrders}
					way={way}
				/>
			)}

			{isCreateReqModalShown && (
				<CreateReqModalComponent
					isModalShown={isCreateReqModalShown}
					setIsModalShown={setIsCreateReqModalShown}
					collection={selectedCollection}
					orders={selectedOrders}
					way={way}
				/>
			)}
		</>
	);
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {};

export const WayContextComponent = connect(mapStateToProps, mapDispatchToProps)(WayContextWrapper);

WayContextWrapper.propTypes = {
	contextMenu: PropTypes.object,
	setContextMenu: PropTypes.func,
	selectedCollection: PropTypes.array,
	selectedOrders: PropTypes.array,
	way: PropTypes.object,
};
